import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import { InfoBox, LbPagination } from '@infoods/lifebase-ui';
import classes from './InvoicesTab.module.scss';
import { HeaderRow } from './HeaderRow/HeaderRow';

import { EmptyList } from '../../../../../shared/components/ui-components';
import { invoicesStore } from '../../../../stores/invoicesStore';
import { InvoiceRow } from './InvoiceRow/InvoiceRow';
import { openModal } from '../../../../../shared/utils/reactUtils/openModal/openModal';
import { InvoiceDetailsModal } from './InvoiceDetailsModal/InvoiceDetailsModal';

type InvoicesTabProps = {
  entityId: number;
};

const InvoicesTab = observer(({ entityId }: InvoicesTabProps) => {
  const { invoices, getInvoices, setDefaultValues, filterMethods } = invoicesStore;

  const { isShowPlaceholder, elementsPerPage, totalElements, getPaginationProps } =
    filterMethods;

  useEffect(() => {
    getInvoices(entityId);

    return () => {
      setDefaultValues();
    };
  }, []);

  const onShowDetailsClick = (invoiceId: number) => {
    openModal((closeModal) => (
      <InvoiceDetailsModal
        entityId={entityId}
        invoiceId={invoiceId}
        onClose={closeModal}
      />
    ));
  };

  return (
    <InfoBox title="Invoice History" customContentPadding>
      <div className={classes.invoicesTable}>
        <HeaderRow />
        {invoices.map((invoice) => (
          <InvoiceRow
            key={invoice.invoiceId}
            invoice={invoice}
            onShowDetailsClick={onShowDetailsClick}
          />
        ))}
        <EmptyList show={isShowPlaceholder} description="There are no invoices" />
      </div>
      <LbPagination
        {...getPaginationProps()}
        elementsPerPage={elementsPerPage}
        totalElements={totalElements}
        variant="inBox"
      />
    </InfoBox>
  );
});

export { InvoicesTab };
